import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ErrorsInterceptorService implements HttpInterceptor{

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError(error=>{
        console.log('Error interceptado:', error);
        let errorMessage="Ocurrió un error desconocido";
        if(error.error instanceof ErrorEvent){
          //client side error
          errorMessage=`Un error ocurrió: ${error.error.message}`;
        } else{
          const gqlMessage = error.error?.errors?.[0]?.message;
          const backendMessage = gqlMessage || error.error?.message || error.error?.error || (typeof error.error === 'string' ? error.error : null);
          
          switch (error.status){
            case 400:
              errorMessage = backendMessage || "Bad Request.";
              break;
            case 404:
              errorMessage = backendMessage || "El resource no existe.";
              break;
            case 500:
              errorMessage = backendMessage || "Internal Server Error.";
              break;
            default:
              if (backendMessage) {
                errorMessage = backendMessage;
              }
          }
        }
        console.log('Mensaje de error:', errorMessage);
        // Retornar el error original para preservar detalles
        return throwError(() => ({ ...error, message: errorMessage }));
      })
    );
  }
}
